import React from 'react';
import './BudgetSummary.css';

const BudgetSummary = ({
  monthlyIncome,
  monthlyExpense,
  monthlySavings,
  yearlyIncome,
  yearlyExpense,
  yearlySavings,
  viewMode
}) => {
  // 通貨フォーマット
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY',
      minimumFractionDigits: 0
    }).format(amount);
  };
  
  // 年間・月間の表示を切り替え
  const displayIncome = viewMode === 'monthly' ? monthlyIncome : yearlyIncome;
  const displayExpense = viewMode === 'monthly' ? monthlyExpense : yearlyExpense;
  const displaySavings = viewMode === 'monthly' ? monthlySavings : yearlySavings;
  const periodLabel = viewMode === 'monthly' ? '月間' : '年間';
  
  // 貯蓄率の計算
  const savingsRate = displayIncome > 0 
    ? Math.round((displaySavings / displayIncome) * 100) 
    : 0;
  
  return (
    <div className="budget-summary">
      <div className="summary-header">
        <h3>{periodLabel}収支サマリー</h3>
      </div>
      
      <div className="summary-items">
        <div className="summary-item income">
          <div className="summary-label">収入</div>
          <div className="summary-value">
            <span className="currency-symbol">¥</span>
            <span className="amount-value">{displayIncome.toLocaleString()}</span>
          </div>
        </div>
        
        <div className="summary-item expense">
          <div className="summary-label">支出</div>
          <div className="summary-value">
            <span className="currency-symbol">¥</span>
            <span className="amount-value">{displayExpense.toLocaleString()}</span>
          </div>
        </div>
        
        <div className={`summary-item balance ${displaySavings >= 0 ? 'positive' : 'negative'}`}>
          <div className="summary-label">差額</div>
          <div className="summary-value">
            <span className="currency-symbol">¥</span>
            <span className="amount-value">{Math.abs(displaySavings).toLocaleString()}</span>
            <span className="sign">{displaySavings >= 0 ? '+' : '-'}</span>
          </div>
        </div>
        
        <div className="summary-item rate">
          <div className="summary-label">貯蓄率</div>
          <div className="summary-value">
            <span className="amount-value">{savingsRate}</span>
            <span className="unit">%</span>
          </div>
        </div>
      </div>
      
      <div className="summary-advice">
        {displaySavings > 0 ? (
          <p>
            {periodLabel}収支は黒字です。貯蓄や投資を検討しましょう。
          </p>
        ) : (
          <p>
            {periodLabel}収支は赤字です。支出の見直しを検討しましょう。
          </p>
        )}
      </div>
    </div>
  );
};

export default BudgetSummary; 